
















import { Component, Vue, Prop, Provide } from "vue-property-decorator";

import nav from "../nav";

import Header from "@/components/header/Header.vue";
import Sidebar from "@/components/sidebar/Sidebar.vue";
import Footer from "@/components/layout/Footer.vue";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import { IRole } from "../models/interfaces/authentication/role.model.interface";

@Component({
    components: {
        Header,
        Sidebar,
        Footer,
        Breadcrumb
    }
})
export default class Full extends Vue {
    @Provide() public navItemList = nav.items;

    get name() {
        return this.$route.name;
    }

    get list() {
        return this.$route.matched;
    }
}
